__turbopack_context__.v({
  "destructive": "i4dWXG_destructive",
  "disabled": "i4dWXG_disabled",
  "highlighted": "i4dWXG_highlighted",
  "icon": "i4dWXG_icon",
  "label": "i4dWXG_label",
  "meta": "i4dWXG_meta",
  "root": "i4dWXG_root",
  "trailingIcon": "i4dWXG_trailingIcon",
});
